import { useCallback, useEffect, useState } from 'react'

import {
    defectoIncluirTests,
    escribirIncluirTests,
    escribirIncluirTestsPortada,
    incluirTestsEnVista,
    leerIncluirTests,
    leerIncluirTestsPortada,
} from './preferencia-tests'

export function useIncluirTests(accountId: string | undefined, esDemo: boolean | undefined) {
    const [valor, setValor] = useState<boolean | null>(() =>
        accountId ? leerIncluirTests(accountId) : null,
    )

    useEffect(() => {
        if (!accountId) return
        const siguiente = defectoIncluirTests(esDemo, leerIncluirTests(accountId))
        if (siguiente !== null) setValor(siguiente)
    }, [accountId, esDemo])

    function cambiar(v: boolean) {
        setValor(v)
        if (accountId) escribirIncluirTests(accountId, v)
    }

    return { incluirTests: valor === true, listo: valor !== null, cambiar }
}

/** Portada admin: recuerda; si nunca se tocó, encendido. (spec 021) */
export function useIncluirTestsPortada(): [boolean, (v: boolean) => void] {
    const [valor, setValor] = useState(leerIncluirTestsPortada)
    const cambiar = useCallback((v: boolean) => {
        setValor(v)
        escribirIncluirTestsPortada(v)
    }, [])
    return [valor, cambiar]
}

/** Resumen, calendario, espera, elevadas: la misma regla (spec 035). */
export function useIncluirTestsVista(
    accountId: string | undefined,
    esDemo: boolean | undefined,
    esAdminUi: boolean,
) {
    const pref = useIncluirTests(accountId, esDemo)
    const resuelto = incluirTestsEnVista(esAdminUi, esDemo, pref.incluirTests)
    return {
        incluirTests: resuelto === true,
        listo: resuelto !== null && (esAdminUi ? pref.listo : true),
        cambiar: pref.cambiar,
        mostrarInterruptor: esAdminUi && esDemo !== true,
    }
}

